<template>
  <div class="tutorial-page">
    <div class="tutorial-scroll">
      <div class="container">

        <div class="video-list">
          <div
            v-for="(video, index) in videos"
            :key="video.videoId"
            class="video-section"
          >
            <h2 class="video-title">{{ video.title }}</h2>

            <div class="video-embed-host">
              <div class="video-frame-wrap">
                <iframe
                  :key="'tutorial-list-' + video.videoId"
                  :src="buildEmbedUrl(video, false)"
                  loading="lazy"
                  class="video-frame"
                  allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture"
                  allowfullscreen="true"
                ></iframe>
              </div>
              <div
                class="video-play-mask"
                @click.stop="onPlayMaskClick(index)"
              ></div>
            </div>

            <button
              type="button"
              class="watched-btn"
              :class="{
                'watched-btn-done': watched[index],
                'watched-btn-disabled': claimed
              }"
              :disabled="claimed"
              @click="toggleWatched(index)"
            >
              <span
                v-if="watched[index]"
                class="watched-btn-check"
                aria-hidden="true"
              >&#10003;</span>
              <span>{{
                watched[index] ? "Marked as watched" : "I have watched this video"
              }}</span>
            </button>
            <hr v-if="index < videos.length - 1" class="video-section-divider" />
          </div>
        </div>
      </div>
    </div>

    <van-popup
      v-model="videoPopupVisible"
      round
      closeable
      position="center"
      :get-container="'body'"
      class="tutorial-video-popup"
      @closed="onVideoPopupClosed"
    >
      <div v-if="popupVideo" class="video-popup-inner">
        <div class="video-popup-title">{{ popupVideo.title }}</div>
        <div class="video-popup-frame-wrap">
          <iframe
            :key="'tutorial-popup-' + videoPopupNonce"
            :src="buildEmbedUrl(popupVideo, true)"
            loading="lazy"
            class="video-popup-frame"
            allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture"
            allowfullscreen="true"
          ></iframe>
        </div>
      </div>
    </van-popup>

    <div class="footer">
      <div
        class="claim-btn"
        :class="{ 'claim-btn-disabled': !canClaim, 'claim-btn-claimed': claimed }"
        @click="claim"
      >
        <template v-if="claimed">Claimed</template>
        <template v-else-if="loading">Processing...</template>
        <template v-else>Claim Reward</template>
      </div>
      <div class="footer-tip" v-if="!claimed">
        Mark all 3 videos as watched to enable the button
      </div>
    </div>
  </div>
</template>

<script>
const TUTORIAL_TASK_MARK = "watchTutorial";

export default {
  name: "tutorial",
  data() {
    return {
      videos: [
        {
          title: "How to Link UPI?",
          libraryId: "656685",
          videoId: "d09322b5-829a-49af-a96d-1b98263764c2"
        },
        {
          title: "How to Buy INR Order?",
          libraryId: "656685",
          videoId: "366585c0-24fc-4652-a707-541a4280bcb9"
        },
        {
          title: "How to Deposit USDT?",
          libraryId: "656685",
          videoId: "7d6bf4a9-664a-438f-82a2-49325962360e"
        }
      ],
      watched: [false, false, false],
      claimed: false,
      loading: false,
      rewardNum: "",
      videoPopupVisible: false,
      videoPopupIndex: null,
      videoPopupNonce: 0
    };
  },
  computed: {
    popupVideo() {
      var i = this.videoPopupIndex;
      if (i === null || i === undefined) return null;
      return this.videos[i] || null;
    },
    canClaim() {
      return (
        !this.claimed &&
        !this.loading &&
        this.watched.every(function(v) {
          return v === true;
        })
      );
    }
  },
  mounted() {
    this.util.title("Tutorial Videos");
    this.prepareUserToken().finally(() => {
      this.fetchTaskStatus();
    });
  },
  methods: {
    parseQueryValue(key) {
      const routeQuery = (this.$route && this.$route.query) || {};
      if (routeQuery[key]) return routeQuery[key];
      const query = window.location.search || "";
      if (!query) return "";
      const params = new URLSearchParams(query.replace(/^\?/, ""));
      return params.get(key) || "";
    },
    prepareUserToken() {
      if (localStorage.getItem("token")) {
        return Promise.resolve(true);
      }
      const tokenFromQuery =
        this.parseQueryValue("token") ||
        this.parseQueryValue("authorization") ||
        this.parseQueryValue("Authorization");
      const userIdFromQuery = this.parseQueryValue("userId");
      if (tokenFromQuery) {
        localStorage.setItem("token", tokenFromQuery);
        if (userIdFromQuery) {
          localStorage.setItem("userId", userIdFromQuery);
        }
        console.log("[教程任务] 已从入口参数同步 token");
        return Promise.resolve(true);
      }
      console.log("[教程任务] 未发现本地 token，尝试调用 getDeviceInfo");
      this.requestDeviceInfo();
      return this.waitTokenReady();
    },
    requestDeviceInfo() {
      try {
        if (
          window.webkit &&
          window.webkit.messageHandlers &&
          window.webkit.messageHandlers.getDeviceInfo
        ) {
          window.webkit.messageHandlers.getDeviceInfo.postMessage("");
          return;
        }
      } catch (e) {
        // ignore
      }
      try {
        if (window.AppJs && typeof window.AppJs.getDeviceInfo === "function") {
          window.AppJs.getDeviceInfo();
        }
      } catch (e) {
        // ignore
      }
    },
    waitTokenReady() {
      return new Promise(resolve => {
        if (localStorage.getItem("token")) {
          resolve(true);
          return;
        }
        let retry = 0;
        const maxRetry = 8;
        const timer = setInterval(() => {
          retry += 1;
          if (localStorage.getItem("token")) {
            clearInterval(timer);
            console.log("[教程任务] getDeviceInfo 回填 token 成功");
            resolve(true);
            return;
          }
          if (retry >= maxRetry) {
            clearInterval(timer);
            console.log("[教程任务] getDeviceInfo 未在预期时间内回填 token");
            resolve(false);
          }
        }, 200);
      });
    },
    buildEmbedUrl(video, autoplay) {
      // Bunny Stream player 嵌入（与 mediadelivery 官方 embed 示例一致）
      return (
        "https://player.mediadelivery.net/embed/" +
        video.libraryId +
        "/" +
        video.videoId +
        "?autoplay=" +
        (autoplay ? "true" : "false") +
        "&loop=false&muted=false&preload=true&responsive=true"
      );
    },
    onPlayMaskClick(index) {
      // 弹窗与点击同一次手势打开，弹窗内 iframe 使用 autoplay，利于移动端自动播放策略
      this.videoPopupIndex = index;
      this.videoPopupNonce += 1;
      this.videoPopupVisible = true;
    },
    onVideoPopupClosed() {
      this.videoPopupVisible = false;
      this.videoPopupIndex = null;
    },
    toggleWatched(index) {
      if (this.claimed) return;
      this.$set(this.watched, index, !this.watched[index]);
    },
    fetchTaskStatus() {
      const that = this;
      this.$get("/app/v1/activityTask/newbie/getList").then(function(res) {
        if (!res || res.code !== 200 || !Array.isArray(res.data)) {
          return;
        }
        const tutorial = res.data.find(function(item) {
          return item.mark === TUTORIAL_TASK_MARK;
        });
        if (!tutorial) return;
        if (tutorial.money) {
          that.rewardNum = String(tutorial.money);
        }
        if (tutorial.status === 1) {
          that.claimed = true;
          that.watched = [true, true, true];
        }
      });
    },
    claim() {
      if (!this.canClaim) return;
      const that = this;
      this.prepareUserToken().finally(function() {
        if (!localStorage.getItem("token")) {
          that.util.toast({
            msg: "未获取到用户信息，请返回重试",
            type: "fail"
          });
          return;
        }
        that.loading = true;
        that.$post(
          "/app/v1/activityTask/newbie/tutorial/complete",
          {},
          true,
          true
        )
          .then(function(res) {
            that.loading = false;
            if (res && res.code === 200) {
              that.claimed = true;
              that.util.toast({
                msg: "Reward claimed!",
                type: "succ"
              });
            } else {
              that.util.toast({
                msg: (res && res.message) || "Failed, please try again",
                type: "fail"
              });
            }
          })
          .catch(function() {
            that.loading = false;
            that.util.toast({
              msg: "Network busy, please try again",
              type: "fail"
            });
          });
      });
    }
  }
};
</script>

<style scoped>
/* 与 paisaBaseIntro.vue 同一套页面/容器/标题/分隔/强调色 */
/* 占满 router-view 高度：中间 tutorial-scroll 滚动，底栏不参与滚动（避免 fixed 落在 .view 滚动层内失效） */
.tutorial-page {
  margin: 0;
  padding: 0;
  height: 100%;
  min-height: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: #f5f7fa;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", sans-serif;
  color: #222444;
  letter-spacing: 0.02em;
  box-sizing: border-box;
}

.tutorial-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.tutorial-page *,
.tutorial-page *::before,
.tutorial-page *::after {
  box-sizing: border-box;
}

.tutorial-page .container {
  max-width: 780px;
  background-color: #fff;
  padding: calc(30px + env(safe-area-inset-top)) 20px 30px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.reward-line {
  font-size: 14px;
  line-height: 1.4;
  color: #999;
  margin: 0 0 24px;
}

.reward-line strong {
  color: #007aff;
  font-weight: 600;
}

.video-list {
  display: flex;
  flex-direction: column;
}

.video-section {
  margin: 0;
}

.tutorial-page .video-title {
  font-size: 20px;
  margin-bottom: 24px;
  padding-left: 10px;
  border-left: 6px solid #007aff;
  line-height: 1;
  font-weight: 600;
  color: #2c3e50;
}

.video-list .video-section:first-child .video-title {
  margin-top: 0;
}

.video-section-divider {
  border: none;
  border-top: 1px solid #eee;
  margin: 36px 0;
}

/* 视频区域 50% 宽居中；竖版 2:3 由内部 padding-top 控制 */
.video-embed-host {
  width: 50%;
  margin: 0 auto;
  position: relative;
  background: #000;
  border-radius: 0;
  overflow: hidden;
}

/* 2:3 竖版占位：padding-top 相对宽度，高/宽 = 3/2 = 150% */
.video-frame-wrap {
  position: relative;
  width: 100%;
  padding-top: 150%;
  background: #000;
}

/* 透明遮罩：拦截首点至全屏逻辑，视觉上与仅 iframe 一致 */
.video-play-mask {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  background: transparent;
}

.video-frame {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.watched-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  margin: 20px 0 0;
  min-height: 48px;
  padding: 14px 20px;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.4;
  color: #666888;
  background-color: #f0f7ff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.watched-btn:active:not(:disabled) {
  opacity: 0.92;
}

.watched-btn-done {
  color: #2c3e50;
  background-color: #e8f4ff;
  border-left-color: #007aff;
}

.watched-btn-check {
  color: #007aff;
  font-size: 16px;
  line-height: 1;
}

.watched-btn-disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.footer {
  flex-shrink: 0;
  z-index: 100;
  padding: 12px 12px calc(14px + env(safe-area-inset-bottom));
  background: #fff;
  border-top: 1px solid #eee;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.05);
}

.claim-btn {
  height: 46px;
  border-radius: 4px;
  background: linear-gradient(to bottom, #1A88FF, #0071EC);
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 0.02em;
}

.claim-btn-disabled {
  background: rgba(0, 0, 0, 0.1);
  color: #AAAAAA;
}

.claim-btn-claimed {
  opacity: 0.55;
  background: #e8f4ff;
  color: #2c3e50;
}

.footer-tip {
  margin-top: 8px;
  text-align: center;
  font-size: 14px;
  color: #999;
}
</style>

<style>
/* van-popup 挂载到 body，需非 scoped 才能命中 */
.tutorial-video-popup.van-popup {
  width: 84vw;
  max-width: 400px;
  background: #fff;
  overflow: hidden;
}

.tutorial-video-popup .video-popup-inner {
  padding: 16px 16px 20px;
}

.tutorial-video-popup .video-popup-title {
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 28px 12px 0;
  line-height: 1.35;
}

.tutorial-video-popup .video-popup-frame-wrap {
  position: relative;
  width: 100%;
  padding-top: 170%;
  background: #000;
  border-radius: 8px;
  overflow: hidden;
}

.tutorial-video-popup .video-popup-frame {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
